var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterOutline = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.92812C0 2.41562 0.415625 2 0.928125 2H15.075C15.5875 2 16.0031 2.41562 16.0031 2.92812C16.0031 3.175 15.9062 3.40937 15.7312 3.58437L10.5 8.80937V15.0719C10.5 15.5844 10.0844 16 9.57187 16C9.325 16 9.09062 15.9031 8.91562 15.7281L5.71875 12.5312C5.57812 12.3906 5.5 12.2 5.5 12V8.80937L0.271875 3.58125C0.096875 3.40937 0 3.17187 0 2.92812ZM2.30938 3.5L6.78125 7.96875C6.92188 8.10938 7 8.3 7 8.5V11.6906L9 13.6906V8.5C9 8.3 9.07812 8.10938 9.21875 7.96875L13.6875 3.5H2.30938Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filterOutline.a04d5ab89676b3a5089d01eb77603c187cf5d19f1c0bb7ed439e44ff54e884c8.svg";